export default __webpack_public_path__ + "static/craig-nazzaro-a96811734b7dfbab4d9f8bf17f218b6b.png";